import { LoaderCircle } from 'lucide-react';

export const Loading = () => {
  return (
    <div className="flex size-full items-center justify-center bg-white">
      <LoaderCircle className="animate size-16 animate-spin text-[var(--primary-color)]" />
    </div>
  );
};
